import React from 'react';
import { Check, Book } from 'lucide-react';
export function TomoSection() {
  const tomos = [{
    color: 'text-green-600',
    title: 'Tomo 1 – Descubriendo el Cuerpo Humano'
  }, {
    color: 'text-blue-600',
    title: 'Tomo 2 – El Centro de Control'
  }, {
    color: 'text-red-600',
    title: 'Tomo 3 – El Motor de la Vida'
  }, {
    color: 'text-orange-600',
    title: 'Tomo 4 – Energía y Movimiento'
  }, {
    color: 'text-purple-600',
    title: 'Tomo 5 – Defensas y Protección'
  }, {
    color: 'text-yellow-600',
    title: 'Tomo 6 – Vivir Saludable Todos los Días'
  }];
  const features = ['Explicaciones claras', 'Actividades prácticas', 'Juegos integrados', 'Proyecto final', 'Repaso evaluativo', 'Certificado para alumnos'];
  return <section className="bg-gray-50 py-10 md:py-14 px-4" data-id="element-210">
      <div className="max-w-3xl mx-auto" data-id="element-211">
        <div className="text-center mb-8" data-id="element-212">
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-2 font-['Oswald'] uppercase" data-id="element-213">
            📘 ¿Qué incluye exactamente el Pack?
          </h2>
          <p className="text-lg text-blue-600 font-bold" data-id="element-214">
            6 Tomos Profesionales
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 items-start mb-8" data-id="element-215">
          <div className="bg-white p-5 rounded-xl shadow-lg border border-gray-100" data-id="element-216">
            <ul className="space-y-3" data-id="element-217">
              {tomos.map((tomo, idx) => <li key={idx} className="flex items-center gap-2 text-sm md:text-base font-bold text-gray-800 border-b border-gray-100 pb-2 last:border-0 last:pb-0" data-id="element-218">
                  <Book className={`w-5 h-5 ${tomo.color} flex-shrink-0`} data-id="element-219" />
                  <span data-id="element-220">{tomo.title}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-blue-50 p-5 rounded-xl border-2 border-blue-200" data-id="element-221">
            <h3 className="text-base font-bold text-blue-900 mb-4 uppercase tracking-wide text-center" data-id="element-222">
              Cada tomo incluye:
            </h3>
            <ul className="space-y-2" data-id="element-223">
              {features.map((feature, idx) => <li key={idx} className="flex items-center gap-2" data-id="element-224">
                  <div className="bg-green-500 rounded-full p-0.5" data-id="element-225">
                    <Check className="w-3 h-3 text-white" data-id="element-226" />
                  </div>
                  <span className="text-sm md:text-base text-gray-700 font-medium" data-id="element-227">
                    {feature}
                  </span>
                </li>)}
            </ul>
            <div className="mt-4 pt-3 border-t border-blue-200 text-center font-bold text-blue-800 text-sm" data-id="element-228">
              Todo organizado para cubrir el programa completo del cuerpo
              humano.
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-229">
          <a href="#compra" className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg font-black py-4 px-8 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase animate-pulse inline-block no-underline" data-id="element-230">
            👉 Acceder con descuento
          </a>
        </div>
      </div>
    </section>;
}